import { AppEnvironment } from '../utils/index.js';
import '../utils/normalizr/constants.js';
import '../utils/normalizr/entities.js';
import 'query-string';
import '@dtvgo/typed-normalizr';
import '@dtvgo/constants';
import '../utils/normalizr/interfaces.js';
import '../utils/normalizr/utils.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';

function createClientHeadersInterceptor({
  clientId,
  appVersion,
  environment,
  appName,
  profileToken
}) {
  async function interceptor(axiosRequestConfig) {
    return {
      ...axiosRequestConfig,
      headers: {
        ...axiosRequestConfig.headers,
        "x-client-id": clientId,
        "x-client-version": typeof appVersion === "function" ? await appVersion() : appVersion,
        "x-app": appName,
        "x-environment": AppEnvironment[environment],
        "x-profile-token": typeof profileToken === "function" ? await profileToken() : profileToken
      }
    };
  }
  return interceptor;
}

export { createClientHeadersInterceptor };
//# sourceMappingURL=clientHeaders.js.map
